export default __webpack_public_path__ + "static/media/practice.a49d7cae.png";